import { createReducer, on } from '@ngrx/store';
import { initialState } from './spare-parts.state';
import { retrievedParts } from './spare-parts.actions';

export const sparePartsReducer = createReducer(
  initialState,
  on(retrievedParts, (state, { parts }) => ({ ...state, parts })),
);
